import { render, staticRenderFns } from "./EventPackageOffersNotAvailableWarning.vue?vue&type=template&id=10e701c4&scoped=true&"
import script from "./EventPackageOffersNotAvailableWarning.vue?vue&type=script&lang=js&"
export * from "./EventPackageOffersNotAvailableWarning.vue?vue&type=script&lang=js&"
import style0 from "./EventPackageOffersNotAvailableWarning.vue?vue&type=style&index=0&id=10e701c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e701c4",
  null
  
)

export default component.exports